function Chat(url: string) {
    return (
        // eslint-disable-next-line jsx-a11y/iframe-has-title
        <iframe src={url} frameBorder="0">

        </iframe>
    )
}
export default Chat